import { WebsiteCategories, WebsiteCategoryCookie } from '@/enums/app'
import { getCookieDomain } from '@/utils/cookie'
import { WomenCountries } from '@/enums/general'
import { useAppStore } from '@/stores/app'
import { defineNuxtRouteMiddleware, useCookie } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to) => {
  const appStore = useAppStore()
  const country = appStore.country

  const cookieOpts = { path: '/', domain: getCookieDomain(), expires: new Date(Date.now() + 604800) }
  const categoryCookie = useCookie(WebsiteCategoryCookie, cookieOpts)

  if (WomenCountries.includes(country as (typeof WomenCountries)[number])) {
    if (to.name) {
      const pathName = extractRouteName(to.name?.toString() || '')

      if (
        pathName === WebsiteCategories.men ||
        pathName.startsWith(`${WebsiteCategories.men}-`) ||
        pathName.startsWith('try-now')
      ) {
        categoryCookie.value = WebsiteCategories.men
      }

      if (pathName === WebsiteCategories.women || pathName.startsWith(`${WebsiteCategories.women}-`)) {
        categoryCookie.value = WebsiteCategories.women
      }
    }
  } else {
    categoryCookie.value = WebsiteCategories.men
  }
})
